<ng-container *ngIf="!isDropdown; else dropdownTemplate">
    <app-modal [isOpen]="isOpen" [title]="title" [subtitle]="currentSubtitle" (cancel)="onCancel()" (done)="onDone()"
        (close)="onCancel()">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </app-modal>
</ng-container>

<ng-template #dropdownTemplate>
    <div class="account-selection-dropdown">
        <div class="dropdown-header">
            <h3 class="dropdown-title">{{ dropdownTitle }}</h3>
            <button class="save-btn" (click)="onDone()">Save</button>
        </div>
        <p class="dropdown-subtitle">{{ currentDropdownSubtitle }}</p>
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
</ng-template>

<ng-template #contentTemplate>
    <!-- Segmented Control -->
    <div class="segmented-control mb-4">
        <button type="button" class="segment-btn" [class.active]="activeTab === 'accounts'"
            (click)="onTabChange('accounts')">
            Accounts
        </button>
        <button type="button" class="segment-btn" [class.active]="activeTab === 'cards'" (click)="onTabChange('cards')">
            Credit Cards
        </button>
    </div>

    <!-- Select All Checkbox -->
    <div class="accounts-list-header" *ngIf="totalCount > 0">
        <div class="account-item select-all-item" (click)="toggleSelectAll()">
            <div class="selection-indicator">
                <div class="checkbox-custom" [class.checked]="isAllSelected"
                    [class.indeterminate]="isPartiallySelected">
                    <img src="assets/icons/tick.svg" class="tick-icon" *ngIf="isAllSelected">
                    <!-- Dash for indeterminate state is handled via CSS or we can use an element if provided -->
                </div>
            </div>
            <div class="account-info">
                <span class="account-name">
                    Select All
                    <span class="text-muted">({{selectedCount}}/{{totalCount}})</span>
                </span>
            </div>
        </div>
    </div>

    <!-- Accounts/Cards List -->
    <div class="accounts-list">
        <div *ngFor="let item of (activeTab === 'accounts' ? accounts : creditCards)" class="account-item"
            [class.selected]="item.selected" (click)="toggleSelection(item)">

            <div class="selection-indicator">
                <div class="checkbox-custom" [class.checked]="item.selected">
                    <img src="assets/icons/tick.svg" class="tick-icon" *ngIf="item.selected">
                </div>
            </div>

            <div class="account-info">
                <div class="name-row">
                    <span class="account-name">{{ item.name | titlecase }}</span>
                    <span class="card-number">**** {{ item.cardNumber }}</span>
                </div>
                <div class="amount" [ngClass]="item.amountColor ? 'amount-' + item.amountColor : ''">
                    {{ item.amount }}
                </div>
                <div class="used-amount" *ngIf="item.usedAmount" [class.over-limit]="isOverLimit(item)">
                    Used: {{ item.usedAmount }}
                </div>
            </div>
        </div>
    </div>
</ng-template>